import { useState, useImperativeHandle, forwardRef, useRef } from 'react'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'

const ImageUploader = forwardRef(({ setFile, disabled }, ref) => {
  const [filename, setFilename] = useState('')
  const inputRef = useRef(null)
  const [isHeic, setIsHeic] = useState(false)

  const handleImageUpload = (e) => {
    const file = e.target.files[0]
    if (!file) return

    if (file.type === 'image/heic') {
      setIsHeic(true)
    } else {
      setIsHeic(false)
      setFile(file)
      setFilename(file.name)
    }
  }

  useImperativeHandle(
    ref,
    () => ({
      clear: () => {
        if (inputRef.current !== null) {
          inputRef.current.value = null
          setFilename('')
        }
      },
    }),
    []
  )

  return (
    <Box>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          input: {
            display: 'none',
          },
        }}
      >
        <label htmlFor="uploader">
          <Button disabled={disabled} variant="contained" component="span">
            Choose
            <input
              ref={inputRef}
              type="file"
              accept="image/*"
              onChange={handleImageUpload}
              id="uploader"
            ></input>
          </Button>
        </label>
        <Box sx={{ ml: 2 }}>{filename}</Box>
        {isHeic && (
          <Box>
            This is an HEIC file, please convert it to a JPG file{' '}
            <Box
              sx={{
                textDecoration: 'underline',
                cursor: 'pointer',
                display: 'inline',
              }}
              onClick={() =>
                window.open('https://www.freeconvert.com/heic-to-jpg', '_blank')
              }
            >
              here
            </Box>{' '}
            and then upload the JPG.
          </Box>
        )}
      </Box>
    </Box>
  )
})

export default ImageUploader
